import React, { useEffect, useRef, useState, useContext, useMemo, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../styles/projectDetails.css";
import "../styles/aiSuggestion.css";
import "../styles/advancedFilters.css";
import Swal from "sweetalert2";
import LoadingIcon from "../images/Loading_icon.gif";
import EmailTemplate from "../components/ProjectDetails/EmailTemplate";
import AISuggestion from "../components/ProjectDetails/AISuggestion";
import MSbuttons from "../components/ProjectDetails/MSbuttons";
import ProjectTitle from "../components/ProjectDetails/ProjectTitle";
import ViewProjectInfo from "../components/ProjectDetails/ViewProjectInfo";
import ProjectExpertRow from "../components/ProjectDetails/ProjectExpertRow";
import StatusList from "../components/ProjectDetails/StatusList";
// import ProjectStatus from "../components/ProjectsOverview/ProjectStatus";
import ProjectDetailsStatus from "../components/ProjectDetails/ProjectDetailsStatus";
import errorRedIcon from "../images/errorRedIcon.png";
import AddLogo from "../components/ProjectDetails/AddLogo";
import { UrlContext } from "../contexts/UrlContext";
import EmailComposer from "./EmailComposer";
import { UserContext } from "../contexts/UserContext";
import ConsultantRequests from "../components/ProjectDetails/ConsultantRequests";
// import JumpingDots from '../images/JumpingDots.gif';
import ProjectCalender from "../components/ProjectDetails/ProjectCalender";
import { AppContext } from "../contexts/AppContext";
import DatabasePopup from "../components/ProjectDetails/DatabasePopup";
import AdvancedFiltersPopup from "../components/ProjectDetails/AdvancedFiltersPopup";
import LinkedInAIModal from "../components/ProjectDetails/LinkedInAIModal";
import { data } from "jquery";
import { set } from "date-fns";
import { he } from "date-fns/locale";
import userDefaultImage from "../images/default-profile.png";
import RejectedRequests from "../components/ProjectDetails/RejectedRequests";
import AISearchModal from "../components/ProjectDetails/AISearchModal";
import { AnimatePresence, motion } from "framer-motion";
import FeedbackModal from "../components/ProjectDetails/FeedbackModal";
import EphProjectCalendar from "../components/ProjectDetails/EphProjectCalendar";
import DatabaseSearchDrawer from "../components/ProjectDetails/DatabaseSearchDrawer";

export default function ProjectDetails() {
  useEffect(() => {
    document.title = "Project Details";
  }, []);
  const { API_URL } = useContext(UrlContext);
  const { sanitize } = useContext(AppContext);
  const id = useParams().id;
  const [searchExpand, setSearchExpand] = useState(false);
  const nameInputRef = useRef(null);
  const locationInputRef = useRef(null);
  const [backupData, setBackupData] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [project, setProject] = useState({});
  const [tableData, setTableData] = useState([]);
  const [showButtons, setShowButtons] = useState(false);
  const [expertIds, setExpertIds] = useState([]);
  const [noConFound, setNoConFound] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [projectInfo, setProjectInfo] = useState(null);
  const [accountDetail, setAccountDetail] = useState(null);
  const [clientLogo, setClientLogo] = useState(false);
  const [addLogoPopUp, setAddLogoPopUp] = useState(false);
  const [continueWithoutLogo, setContinueWithoutLogo] = useState(false);
  const [clientid, setClientid] = useState(null);
  const [composeEmail, setComposeEmail] = useState(false);
  const [emailDetails, setEmailDetails] = useState(false);
  const [fieldsLoading, setFieldsLoading] = useState(false);
  const [filterLocation, setFilterLocation] = useState(null);
  const [locationExpand, setLocationExpand] = useState(false);
  const { userData } = useContext(UserContext);
  const [showProjectInfo, setShowProjectInfo] = useState(false);
  const [projectLost, setProjectLost] = useState(false);
  const [otherSelected, setOtherSelected] = useState(false);
  const [reasonLost, setReasonLost] = useState("");
  const [screeningQuestions, setScreeningQuestions] = useState([]);
  const [reasonLostOptions, setReasonLostOptions] = useState([
    "Other candidates were selected",
    "Consultants not a good fit",
    "Consultants too expensive",
    "Client proposal was not won",
    "No feedback from the client",
    "Delivery too slow",
    "No profiles found",
    "Project postponed",
    "Others",
  ]);
  const statusOrder = {
    Participated: 1,
    Contracting: 2,
    Responded: 3,
    Interested: 4,
    "Partially Available": 5,
    0: 6,
    "Not Interested": 7,
  };

  const [projectStatus, setProjectStatus] = useState("");
  const [feedback, setFeedback] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);
  // const [titleCount, setTitleCount] = useState(0)
  // const [filterCount, setFilterCount] = useState(0)
  const [emailButtonClicked, setEmailButtonClicked] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedConsulData, setSelectedConsulData] = useState("");
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [isProjectCalendarOpen, setIsProjectCalendarOpen] = useState(false);
  const [projStartDate, setProjStartDate] = useState("");
  const [projDeadline, setProjDeadline] = useState("");
  const [projLanguages, setProjLanguages] = useState([]);
  const [showEmailTemplate, setShowEmailTemplate] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [openLinkedinSearch, setOpenLinkedinSearch] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [currentExpertID, setCurrentExpertID] = useState(null);
  const [doRefresh, setDoRefresh] = useState(false);
  const navigate = useNavigate();
  const [projectSupporter, setProjectSupporter] = useState(null);
  const databaseLink = "https://images.expertpowerhouse.com";
  const [applyCounter, setApplyCounter] = useState(null);
  const [expertSuggestions, setExpertSuggestions] = useState(null);
  const [suggestionFetched, setSuggestionFetched] = useState(false);
  const [isSuggestionFetching, setIsSuggestionFetching] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [projectFilters, setProjectFilters] = useState(null);
  // Last filters the LinkedIn popup autosaved; the popup unmounts on close, so reopening starts from these
  const [savedLinkedinFilters, setSavedLinkedinFilters] = useState({});
  const [allProjectFilters, setAllProjectFilters] = useState(null);
  const [showAISearchModal, setShowAISearchModal] = useState(false);
  const { aiSearchResults, setAiSearchResults } = useContext(AppContext);
  const [aiSearchLoading, setAiSearchLoading] = useState(false);
  const [isLinkCreated, setIsLinkCreated] = useState(false);

  const [linkedinProfilesData, setLinkedinProfilesData] = useState(null);
  const [loadingLinkedinProfiles, setLoadingLinkedinProfiles] = useState(false);
  const [showLinkedInAIModal, setShowLinkedInAIModal] = useState(false);

  // Database Search V2 uses the shared addToProject backend workflow.
  // Reuse the existing project-details refresh so ProjectExpertRow receives
  // the exact same payload shape as the normal project-details API.
  const handleDatabaseSearchAdd = useCallback(async (expert) => {
    const expertID = Number(expert?.id);
    if (!Number.isSafeInteger(expertID) || expertID <= 0) {
      throw new Error("Invalid expert ID.");
    }

    let token = "";
    try {
      token = JSON.parse(localStorage.getItem("eph-token") || "null")?.value || "";
    } catch (_) {
      // A missing/invalid session must not be treated as a successful add.
    }
    if (!token) throw new Error("Your session has expired. Please log in again.");

    const url = `${String(API_URL || "").replace(/\/+$/, "")}/database-search-v2/add-to-project`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ projectID: Number(id), expertID }),
    });

    const result = await response.json().catch(() => ({}));
    if (!response.ok || result.status !== "success") {
      throw new Error(result.message || result.text || "Could not add this profile to the project.");
    }

    // Even if another user already added the profile, refresh this page so
    // ProjectExpertRow reflects the database without a full page reload.
    if (result.alreadyInProject === true) {
      setDoRefresh(previous => !previous);
    }
    return result;
  }, [API_URL, id]);

  const fetchLinkedInProfiles = useCallback((silent = false) => {
    if (!id) return;
    if (!silent) {
      setLoadingLinkedinProfiles(true);
    }
    const tokenObj = localStorage.getItem("eph-token");
    const token = tokenObj ? JSON.parse(tokenObj).value : null;

    fetch(`${API_URL}projects/${id}/linkedin-profiles`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch profiles");
        }
        return res.json();
      })
      .then((data) => {
        setLinkedinProfilesData(data);
      })
      .catch((err) => {
        console.error("Error fetching linkedin profiles:", err);
        setLinkedinProfilesData(null);
      })
      .finally(() => {
        if (!silent) {
          setLoadingLinkedinProfiles(false);
        }
      });
  }, [id, API_URL]);

  useEffect(() => {
    if (id) {
      fetchLinkedInProfiles();
    }
  }, [id, fetchLinkedInProfiles]);

  // Listen for extension add-profile response to reload project experts even if modal is closed
  useEffect(() => {
    const handleExtensionProfileAdded = (event) => {
      if (event.source !== window || !event.data) return;
      if (
        event.data.type === "EPH_ADD_PROFILE_RESULT" &&
        event.data.response?.success
      ) {
        setDoRefresh((prev) => !prev);
      }
    };

    window.addEventListener("message", handleExtensionProfileAdded);
    return () => {
      window.removeEventListener("message", handleExtensionProfileAdded);
    };
  }, []);

  const handleLinkedInDiscardSuccess = (discardedProfileUrl) => {
    setLinkedinProfilesData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        active_profiles: (prev.active_profiles || []).filter(
          (profile) => profile.profile_url !== discardedProfileUrl
        ),
        discarded_profiles: [
          ...(prev.discarded_profiles || []),
          {
            profile_url: discardedProfileUrl,
            discarded_at: new Date().toISOString(),
          },
        ],
      };
    });
  };

  const handleAISearch = () => {
    setShowAISearchModal(true);
  };

  const closeLinkedinSearch = () => {
    if (openLinkedinSearch) {
      fetchLinkedInProfiles();
    }
    setOpenLinkedinSearch(!openLinkedinSearch);
  };

  // Transform projectFilters data to match AdvancedFiltersPopup format
  const transformProjectFiltersToAdvancedFilters = (projectFilters) => {
    if (!projectFilters) return {};

    const transformedFilters = {};

    console.log(
      "Transforming projectFilters:",
      projectFilters.hasOwnProperty("projType")
    );

    if (projectFilters.hasOwnProperty("projType")) {
      // Location
      if (projectFilters.location) {
        transformedFilters.locations = [projectFilters.location];
      }

      // Industry
      if (projectFilters.industry) {
        if (projectFilters.industry !== "No industry preference"){
          transformedFilters.industries = [projectFilters.industry];
        } 
      }

      // Languages (comma-separated string to array)
      if (projectFilters.languages) {
        transformedFilters.languages = projectFilters.languages
          .split(",")
          .map((lang) => lang.trim())
          .filter((lang) => lang.length > 0);
      }

      // Skills (comma-separated string to array)
      if (projectFilters.skills) {
        transformedFilters.skills = projectFilters.skills
          .split(",")
          .map((skill) => skill.trim())
          .filter((skill) => skill.length > 0);
      }

      // Experience (map to the format expected by AdvancedFiltersPopup)
      if (projectFilters.experience) {
        // Map experience strings to the standardized format
        const experienceMapping = {
          'Junior (less than 5 years)': ['Less than 1 year', '1 to 2 years', '3 to 5 years'],
          'Mid-level (5-14 years)': ['6 to 10 years', 'More than 10 years'],
          'Senior (15+ years)': ['More than 10 years'],
          'Entry Level': ['Less than 1 year'],
          'Experienced': ['6 to 10 years', 'More than 10 years']
        };

        // Split comma-separated experience values and map each one
        const experienceValues = projectFilters.experience
          .split(",")
          .map((exp) => exp.trim())
          .filter((exp) => exp.length > 0);

        // Map each experience value and flatten the results
        const mappedExperiences = experienceValues
          .map((exp) => experienceMapping[exp] || [exp])
          .flat();

        // Remove duplicates
        transformedFilters.yearsOfExperience = [...new Set(mappedExperiences)];
      }

      // Project Category could map to job titles or industries depending on your data structure
      // if (projectFilters.projCategory) {
      //   // Add to both industries and job titles for broader matching
      //   if (!transformedFilters.industries) {
      //     transformedFilters.industries = [];
      //   }
      //   transformedFilters.industries.push(projectFilters.projCategory);

      //   // Also add as title for job title matching
      //   if (!transformedFilters.title) {
      //     transformedFilters.title = [];
      //   }
      //   // transformedFilters.title.push(projectFilters.projCategory);
      // }

      // Add job titles based on projType
      if (projectFilters.projType) {
        if (!transformedFilters.title) {
          transformedFilters.title = [];
        }

        // Define job titles for consultant projects (projType = "con")
        const consultantTitles = [
          "Independent Consultant",
          "Freelance",
          "Self Employed",
          "Independent Contractor",
          "Professional Freelancer",
          "Freelance Consultant",
          "Independent Owner",
          "Founder",
        ];

        // Define job titles for interim projects (projType = "int")
        const interimTitles = [
          "Interim Manager",
          "Interim Director",
          "Interim Management Specialist",
          "Interim Chief Executive Officer",
          "Interim Chief Financial Officer",
        ];

        // Add appropriate job titles based on projType
        if (
          projectFilters.projType === "con" ||
          projectFilters.projType === "int"
        ) {
          transformedFilters.title = [
            ...transformedFilters.title,
            ...consultantTitles,
            ...interimTitles,
          ];
        }
      }
    } else {
      if (projectFilters.locations) {
        const processed = safelySplitAndFilter(projectFilters.locations);
        if (processed.length > 0) {
          transformedFilters.locations = processed;
        }
      }

      if (projectFilters.title) {
        const processed = safelySplitAndFilter(projectFilters.title);
        if (processed.length > 0) {
          transformedFilters.title = processed;
        }
      }

      if (projectFilters.industries) {
        const processed = safelySplitAndFilter(projectFilters.industries);
        if (processed.length > 0) {
          transformedFilters.industries = processed;
        }
      }

      if (projectFilters.companies) {
        const processed = safelySplitAndFilter(projectFilters.companies);
        if (processed.length > 0) {
          transformedFilters.companies = processed;
        }
      }

      // Fix: keywords should go to keywords, not companies
      if (projectFilters.keywords) {
        const processed = safelyHandleSingleValue(projectFilters.keywords);
        if (processed.trim().length > 0) {
          transformedFilters.keywords = [processed.trim()];
        }
      }

      if (projectFilters.languages) {
        const processed = safelySplitAndFilter(projectFilters.languages);
        if (processed.length > 0) {
          transformedFilters.languages = processed;
        }
      }

      if (projectFilters.skills) {
        const processed = safelySplitAndFilter(projectFilters.skills);
        if (processed.length > 0) {
          transformedFilters.skills = processed;
        }
      }

      if (projectFilters.yearsOfExperience) {
        const processed = safelySplitAndFilter(
          projectFilters.yearsOfExperience
        );
        if (processed.length > 0) {
          transformedFilters.yearsOfExperience = processed;
        }
      }
      transformedFilters.created_by = projectFilters.created_by;
      transformedFilters.ID = projectFilters.ID;
    }

    return transformedFilters;
  };

  // Helper function to safely split comma-separated values
  const safelySplitAndFilter = (value) => {
    if (!value) return [];

    // Handle different data types
    if (typeof value === "string") {
      return value
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item.length > 0);
    }

    // If it's already an array, return as is
    if (Array.isArray(value)) {
      return value.filter(
        (item) => item && typeof item === "string" && item.trim().length > 0
      );
    }

    // If it's neither string nor array, convert to string and try to split
    try {
      return String(value)
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item.length > 0);
    } catch (error) {
      console.warn("Failed to process value:", value, error);
      return [];
    }
  };

  // Helper function to safely handle single values
  const safelyHandleSingleValue = (value) => {
    if (!value) return "";

    if (typeof value === "string") {
      return value.trim();
    }

    if (Array.isArray(value)) {
      return value.length > 0 ? String(value[0]).trim() : "";
    }

    try {
      return String(value).trim();
    } catch (error) {
      console.warn("Failed to process single value:", value, error);
      return "";
    }
  };

  // Stable reference so parent re-renders (e.g. the sticky-nav scroll handler) don't reset the popup's edits.
  // Must stay below the helpers above: the transform calls them during render.
  const linkedinInitialFilters = useMemo(
    () => ({
      ...transformProjectFiltersToAdvancedFilters(projectFilters),
      ...activeFilters,
      ...savedLinkedinFilters,
    }),
    [projectFilters, activeFilters, savedLinkedinFilters]
  );

  const handleApplyFilters = async (filters) => {
    setActiveFilters(filters);

    // Apply filters to backupData (original data source)
    let filtered = [...backupData];

    // Location filter
    if (filters.locations && filters.locations.length > 0) {
      filtered = filtered.filter((item) =>
        filters.locations.some((locationObj) => {
          const locationValue = typeof locationObj === 'string' ? locationObj : locationObj.value;
          return item.expert?.location?.toLowerCase().includes(locationValue.toLowerCase());
        })
      );
    }

    // Industry filter
    if (filters.industries && filters.industries.length > 0) {
      filtered = filtered.filter((item) =>
        filters.industries.some((industryObj) => {
          const industryValue = typeof industryObj === 'string' ? industryObj : industryObj.value;
          return item.expert?.industry?.toLowerCase().includes(industryValue.toLowerCase());
        })
      );
    }

    // Job Title filter (using 'title' property from AdvancedFiltersPopup)
    if (filters.title && filters.title.length > 0) {
      filtered = filtered.filter((item) =>
        filters.title.some((titleObj) => {
          const titleValue = typeof titleObj === 'string' ? titleObj : titleObj.value;
          return item.expert?.jobTitle?.toLowerCase().includes(titleValue.toLowerCase()) ||
                 item.expert?.title?.toLowerCase().includes(titleValue.toLowerCase());
        })
      );
    }

    // Years of Experience filter (using 'yearsOfExperience' property from AdvancedFiltersPopup)
    if (filters.yearsOfExperience && filters.yearsOfExperience.length > 0) {
      filtered = filtered.filter((item) => {
        const expertExperience =
          item.expert?.yearsOfExperience || item.expert?.experienceLevel;
        return filters.yearsOfExperience.some((expLevelObj) => {
          const expLevel = typeof expLevelObj === 'string' ? expLevelObj : expLevelObj.value;
          // Handle both string labels and numeric values
          if (typeof expertExperience === "number") {
            // Map experience ranges to numeric values
            if (expLevel === "Less than 1 year") return expertExperience < 1;
            if (expLevel === "1 to 2 years")
              return expertExperience >= 1 && expertExperience <= 2;
            if (expLevel === "3 to 5 years")
              return expertExperience >= 3 && expertExperience <= 5;
            if (expLevel === "6 to 10 years")
              return expertExperience >= 6 && expertExperience <= 10;
            if (expLevel === "More than 10 years") return expertExperience > 10;
          }
          // Fallback to string comparison
          return (
            expertExperience === expLevel ||
            (typeof expertExperience === "string" &&
              expertExperience.toLowerCase().includes(expLevel.toLowerCase()))
          );
        });
      });
    }

    // Skills filter
    if (filters.skills && filters.skills.length > 0) {
      filtered = filtered.filter((item) =>
        filters.skills.some((skillObj) => {
          const skillValue = typeof skillObj === 'string' ? skillObj : skillObj.value;
          return item.expert?.skills?.some((expertSkill) =>
            expertSkill.toLowerCase().includes(skillValue.toLowerCase())
          );
        })
      );
    }

    // Companies filter (new addition to match AdvancedFiltersPopup)
    if (filters.companies && filters.companies.length > 0) {
      filtered = filtered.filter((item) =>
        filters.companies.some((companyObj) => {
          const companyValue = typeof companyObj === 'string' ? companyObj : companyObj.value;
          return item.expert?.company?.toLowerCase().includes(companyValue.toLowerCase()) ||
                 item.expert?.currentCompany?.toLowerCase().includes(companyValue.toLowerCase()) ||
                 item.expert?.previousCompanies?.some((prevCompany) =>
                   prevCompany.toLowerCase().includes(companyValue.toLowerCase())
                 );
        })
      );
    }

    // Languages filter
    if (filters.languages && filters.languages.length > 0) {
      filtered = filtered.filter((item) =>
        filters.languages.some((langObj) => {
          const langValue = typeof langObj === 'string' ? langObj : langObj.value;
          return item.expert?.languages?.some((expertLang) =>
            expertLang.toLowerCase().includes(langValue.toLowerCase())
          );
        })
      );
    }

    // Keywords filter
    if (filters.keywords && filters.keywords.length > 0) {
      filtered = filtered.filter((item) =>
        filters.keywords.some((keywordObj) => {
          const keywordValue = typeof keywordObj === 'string' ? keywordObj : keywordObj.value;
          const keywordLower = keywordValue.toLowerCase();
          return (
            // Check in expert bio/description
            item.expert?.bio?.toLowerCase().includes(keywordLower) ||
            item.expert?.description?.toLowerCase().includes(keywordLower) ||
            // Check in expert summary
            item.expert?.summary?.toLowerCase().includes(keywordLower) ||
            // Check in expert skills
            item.expert?.skills?.some((skill) =>
              skill.toLowerCase().includes(keywordLower)
            ) ||
            // Check in expert experience/projects
            item.expert?.experience?.some(
              (exp) =>
                exp.description?.toLowerCase().includes(keywordLower) ||
                exp.title?.toLowerCase().includes(keywordLower)
            ) ||
            // Check in expert name
            item.expert?.name?.toLowerCase().includes(keywordLower) ||
            item.expert?.firstName?.toLowerCase().includes(keywordLower) ||
            item.expert?.lastName?.toLowerCase().includes(keywordLower)
          );
        })
      );
    }

    // Rate filter (keeping existing logic for backward compatibility)
    if (filters.rateRange) {
      if (filters.rateRange.min) {
        filtered = filtered.filter(
          (item) => item.expert?.hourlyRate >= parseFloat(filters.rateRange.min)
        );
      }
      if (filters.rateRange.max) {
        filtered = filtered.filter(
          (item) => item.expert?.hourlyRate <= parseFloat(filters.rateRange.max)
        );
      }
    }

    // Availability filter (keeping existing logic for backward compatibility)
    if (filters.availability && filters.availability !== "any") {
      filtered = filtered.filter(
        (item) => item.expert?.availability === filters.availability
      );
    }

    // Verification filter (keeping existing logic for backward compatibility)
    if (filters.verification && filters.verification !== "any") {
      filtered = filtered.filter(
        (item) => item.expert?.verification === filters.verification
      );
    }

    // Response time filter (keeping existing logic for backward compatibility)
    if (filters.responseTime && filters.responseTime !== "any") {
      filtered = filtered.filter(
        (item) => item.expert?.responseTime === filters.responseTime
      );
    }

    // Rating filter (keeping existing logic for backward compatibility)
    if (filters.minRating && filters.minRating > 0) {
      filtered = filtered.filter(
        (item) => item.expert?.rating >= filters.minRating
      );
    }

    setFilteredTableData(filtered);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    selectedConsulData["lang"] = event.target.value;
    setEmailButtonClicked(false);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}send-email`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(selectedConsulData, { lang: event.target.value }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          // setEmailCount(emailCount+1)
          window.location.reload();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Database connection failed!",
        });
      });
  };

  const appendExpertId = (id) => {
    const newExpertIds = [...expertIds];
    newExpertIds.push(id);
    setExpertIds(newExpertIds);
  };
  const removeExpertId = (id) => {
    const newExpertIds = expertIds.filter((expertId) => expertId !== id);
    setExpertIds(newExpertIds);
  };

  useEffect(() => {
    if (expertIds.length > 0) {
      setShowButtons(true);
    } else {
      setShowButtons(false);
    }
  }, [expertIds]);

  const loadFeedbackState = () => {
    const t = JSON.parse(localStorage.getItem("eph-token")).value;
    fetch(`${API_URL}project-feedback/${id}`, { headers: { "x-access-token": t } })
      .then((r) => r.json())
      .then((d) => d.status === "success" && setFeedback(d))
      .catch(() => {});
  };
  useEffect(loadFeedbackState, [id, projectStatus]);

  // Reset filtered data when backupData changes (actual data source)
  useEffect(() => {
    setFilteredTableData([]);
    setActiveFilters({});
  }, [backupData]);

  useEffect(() => {
    const url = `${API_URL}get-project-name/` + id;
    const getProjectName = async () => {
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setProject(data.project);
        })
        .catch((err) => console.log(err));
    };
    getProjectName();
  }, []);

  // Fetch project details
  useEffect(() => {
    const url = `${API_URL}project-details/` + id;
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const getProjectDetails = async () => {
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.tableData) {
            setDataFetched(true);
            setIsLinkCreated(data.isLinkCreated);
            setProjectFilters(data.projectFilters);
            setApplyCounter(data.applyCounter);
            if (data.projectSupporter.length > 0) {
              getProjectSupporter(data.projectSupporter);
            }
            sortTableData(data.tableData);
            if (data.screeningQuestions) {
              setScreeningQuestions(data.screeningQuestions);
            }
          }
        })
        .catch((err) => console.log(err));
    };
    getProjectDetails();
  }, [id, doRefresh]);

  //project filters
  useEffect(() => {
    const url = `${API_URL}project-filters/` + id;
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const getProjectFilters = async () => {
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            console.log(data.allProjectFilters);
            setAllProjectFilters(data.allProjectFilters);
          }
        })
        .catch((err) => console.log(err));
    };
    getProjectFilters();
  }, []);

  // API to fetch project supporters
  const getProjectSupporter = async (nameList) => {
    const url = `${API_URL}get-project-supporter`;
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ nameList: nameList }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setProjectSupporter(data.projectSupporter);
        }
      })
      .catch((err) => console.log(err));
  };

  // Sort data whenever tableData changes
  const sortTableData = async (tableData) => {
    const sortedData = [...tableData].sort(
      (a, b) =>
        (statusOrder[a.expertStatus] || 100) -
        (statusOrder[b.expertStatus] || 100)
    );
    setTableData(sortedData);
    setBackupData(sortedData);
  };

  useEffect(() => {
    if (tableData.length > 0) {
      const sortedData = [...tableData].sort(
        (a, b) =>
          (statusOrder[a.expertStatus] || 100) -
          (statusOrder[b.expertStatus] || 100)
      );

      // Only update state if sorting actually changes the order
      if (JSON.stringify(sortedData) !== JSON.stringify(tableData)) {
        setTableData(sortedData);
        setBackupData(sortedData);
      }
    }
  }, [JSON.stringify(tableData)]);

  const expertList = useMemo(() => {
    return (tableData || [])
      .filter((row) => row.expert?.isDigitalExist)
      .map((row) => row.expert);
  }, [tableData]);

  useEffect(() => {
    if (filterName && statusFilter) {
      const filteredData = backupData.filter((item) => {
        const name = item?.expert.Name.toLowerCase();
        const status = item?.expertStatus.toLowerCase();
        return (
          name.includes(filterName.toLowerCase()) &&
          status.includes(statusFilter.toLowerCase())
        );
      });
      setTableData(filteredData);
    } else if (filterName) {
      const filteredData = backupData.filter((item) => {
        const name = item?.expert.Name.toLowerCase();
        return name.includes(filterName.toLowerCase());
      });
      setTableData(filteredData);
    } else if (statusFilter) {
      const filteredData = backupData.filter((item) => {
        const status = item?.expertStatus.toLowerCase();
        return status === statusFilter.toLowerCase();
      });
      setTableData(filteredData);
    } else if (filterLocation) {
      const filteredData = backupData.filter((item) => {
        const location = item?.expert.location.toLowerCase();
        return location.includes(filterLocation.toLowerCase());
      });
      setTableData(filteredData);
    } else {
      setTableData(backupData);
    }
    // setFilterCount(filterCount + 1)
  }, [filterName, statusFilter, filterLocation, backupData]);

  const handlePopupAction = (e) => {
    if (e.target.id === "closeProject") {
    } else if (e.target.id === "addDetails") {
      window.location.href = "/app/ProjectInformation/" + project.id;
      return;
    }
  };
  useEffect(() => {
    const url = `${API_URL}view-project-info/` + id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setProjectInfo(data.projectInfo);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    const url = `${API_URL}account-details/` + id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setAccountDetail(data.account);
        setClientid(data.account.id);
        if (data.account.clientLogo) {
          setClientLogo(true);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // Bappi 11.03.2025: Not sure about the use cases but it is definitely creating re-rendering issues
  // useEffect(() => {
  //   setFieldsLoading(true);
  //   setTimeout(() => setFieldsLoading(false), 10);
  // }, [tableData]);

  const onOptionChange = (value) => {
    // console.log(value)
    if (value) {
      setReasonLost(value);
      if (value === "Others") {
        setOtherSelected(true);
      } else {
        setOtherSelected(false);
      }
    }
  };

  const handleSubmitReason = () => {
    console.log(reasonLost);
    setProjectLost(false);
    setLoadingPopup(true);
    setProjectStatus("Project Closed (Lost)");
    const selectedProjectStatus = "Project Closed (Lost)";
    const projectID = id;
    const projectData = {
      selectedProjectStatus,
      projectID,
    };
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;

    fetch(`${API_URL}update-project-status`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ data: projectData, reason: reasonLost }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingPopup(false);
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: data.message,
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          // setReturnSuccess(true);
          // setTimeout(() => {
          //   setReturnSuccess(false);
          // }, 1500);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error updating the project status.",
            text: "Please try again.",
            confirmButtonText: "OK",
          });
          // setReturnError(true);
        }
      })
      .catch((err) => {
        setLoadingPopup(false);
        // setReturnError(true);
        Swal.fire({
          icon: "error",
          title: "Database connection error!",
          text: "Please logout and try again.",
          confirmButtonText: "OK",
        });
        console.log(err);
      });
  };
  useEffect(() => {
    if (projectInfo?.projStartDate) {
      const date = new Date(projectInfo.projStartDate);
      if (isNaN(date)) return;
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const formattedDate = `${day < 10 ? "0" + day : day}/${
        month < 10 ? "0" + month : month
      }/${date.getFullYear()}`;
      setProjStartDate(formattedDate);
    }
  }, [projectInfo?.projStartDate]);

  useEffect(() => {
    if (projectInfo?.projDeadline) {
      const date = new Date(projectInfo.projDeadline);
      if (isNaN(date)) return;
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const formattedDate = `${day < 10 ? "0" + day : day}/${
        month < 10 ? "0" + month : month
      }/${date.getFullYear()}`;
      setProjDeadline(formattedDate);
    }
  }, [projectInfo?.projDeadline]);

  useEffect(() => {
    if (projectInfo?.languageList?.length > 0) {
      const languages = projectInfo.languageList.map((language) => {
        const base = language.languageCode;
        const withRequirement =
          language.requirement && language.requirement !== ""
            ? `${base} (${language.requirement})`
            : base;
        return withRequirement + ", ";
      });
      languages[languages.length - 1] = languages[languages.length - 1].slice(
        0,
        -2
      );
      setProjLanguages(languages);
    }
  }, [projectInfo?.languageList]);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 85);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navbarStyle = {
    position: "sticky",
    top: "78px",
    width: "100%",
    backgroundColor: isSticky ? "rgba(255, 255, 255, 0.3)" : "none",
    backdropFilter: isSticky ? "blur(3px)" : "none",
    transition: "all 0.3s ease-in-out",
    zIndex: 10,
    height: "50px",
  };

  const handleSuggestionClose = () => {
    setSuggestionFetched(false);
    setExpertSuggestions(null);
  };

  const fetchSuggestions = async () => {
    if (!id) return;

    Swal.fire({
      title: "Fetching Suggestions...",
      text: "Results will be displayed once ready.",
      icon: "info",
      timer: 2500, // auto close in 2s
      showConfirmButton: false,
    });

    try {
      setIsSuggestionFetching(true);
      const url = `${API_URL}rank-experts`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ projectID: id }),
      });

      const result = await response.json();

      if (Array.isArray(result)) {
        setExpertSuggestions(result);
        setSuggestionFetched(true); // this triggers <ExpertSuggestionPanel />
      } else {
        console.warn("Unexpected data format from /api/rank-experts");
      }
    } catch (error) {
      console.error("Failed to fetch expert suggestions:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to fetch suggestions.",
      });
    } finally {
      setIsSuggestionFetching(false);
    }
  };

  return (
    <>
      <ProjectTitle project={project} />

      {dataFetched ? (
        <div className="relative flex items-center justify-center">
          {/* <div className="container-div"> */}
          <div className="w-[97%]">
            <div className="project-inside-navbar flex w-full justify-between items-center" style={navbarStyle}>
              {addLogoPopUp && !continueWithoutLogo ? (
                <AddLogo
                  project_id={id}
                  setContinueWithoutLogo={setContinueWithoutLogo}
                  clientId={clientid}
                />
              ) : null}
              <StatusList
                project_id={id}
                tableData={tableData}
                applyCounter={applyCounter}
              />

              <div className="project-navbar-right flex items-center min-w-0 flex-nowrap">
                  {showButtons && (
                    <MSbuttons
                      clientLogo={clientLogo}
                      project_id={id}
                      expertIds={expertIds}
                      continueWithoutLogo={continueWithoutLogo}
                      setContinueWithoutLogo={setContinueWithoutLogo}
                      setAddLogoPopUp={setAddLogoPopUp}
                      project_name={project?.name}
                      client_name={project?.clientName}
                      setEmailDetails={setEmailDetails}
                      setComposeEmail={setComposeEmail}
                    />
                  )}

                <div className="dropdown">
                  <button
                    className="btn dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Info
                  </button>

                  <div
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                    style={{ width: "200px", textAlign: "center" }}
                  >
                    <Link
                      to={`/app/ProjectSummary/${id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="btn" style={{ width: "100%" }}>
                        <i className="fa-solid fa-chart-column" /> Summary
                      </button>
                    </Link>
                    <Link to={`/app/AccountDetails/${id}`}>
                      <button
                        className="btn dropdown-item"
                        style={{ width: "100%" }}
                      >
                        <i className="fa-regular fa-address-book" /> Account
                        Details
                      </button>
                    </Link>
                    {projectInfo ? (
                      <ViewProjectInfo
                        projectInfo={projectInfo}
                        setShowProjectInfo={setShowProjectInfo}
                      />
                    ) : null}
                    <button
                      className="btn dropdown-item"
                      onClick={() => setIsProjectCalendarOpen(true)}
                    >
                      <a>
                        <i class="fa-solid fa-calendar-days"></i> Project Calendar
                      </a>
                    </button>
                  </div>
                </div>
                <div className="dropdown">
                  <button
                    className="btn dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {isSuggestionFetching ? (
                      <i class="fa-solid fa-spinner fa-spin"></i>
                    ) : (
                      "Actions"
                    )}
                  </button>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                    style={{ width: "200px", textAlign: "center" }}
                  >
                    <button
                      className="btn"
                      onClick={() => fetchSuggestions()}
                      style={{ width: "100%" }}
                    >
                      <i className="fa-solid fa-arrow-up-right-from-square" /> AI
                      Suggestion
                    </button>
                    <button
                      className="btn"
                      onClick={() => setShowEmailTemplate(true)}
                      style={{ width: "100%" }}
                    >
                      <i className="fa-regular fa-envelope" /> Template
                    </button>
                  </div>
                </div>
                
                {isLinkCreated && (
                  <button
                    className="btn flex items-center gap-1 max-w-[160px] overflow-hidden"
                    onClick={() => {
                      window.open("/app/SharedProfiles/" + id, "_blank");
                    }}
                  >
                    <i class="fa-regular fa-eye shrink-0"></i> 
                    <span className="truncate min-w-0">Client Env.</span>
                  </button>
                )}

                <button
                  className="btn flex items-center gap-1 max-w-[160px] overflow-hidden"
                  onClick={() => setOpenSearch(true)}
                >
                  <i className="fa-solid fa-database shrink-0" />
                  <span className="truncate min-w-0">Search database</span>
                </button>

                <button 
                  className="btn max-w-[120px] flex items-center gap-1 overflow-hidden" 
                  onClick={handleAISearch}
                >
                  <i className="fa-solid fa-robot shrink-0" /> 
                  <span className="truncate">AI Search</span>
                </button>

                <button 
                  className="btn max-w-[170px] flex items-center gap-1 overflow-hidden" 
                  onClick={() => closeLinkedinSearch()}
                >
                  <i className="fa fa-linkedin shrink-0" />
                  <span className="truncate">Search LinkedIn</span>
                </button>

                {linkedinProfilesData?.active_profiles && linkedinProfilesData.active_profiles.length > 0 && (
                  <button 
                    className="btn flex items-center gap-1 overflow-hidden" 
                    onClick={() => {
                      fetchLinkedInProfiles();
                      setShowLinkedInAIModal(true);
                    }}
                    title="LinkedIn AI Recommendation"
                  >
                    <i className="fa fa-linkedin shrink-0" />
                    <span className="truncate">LinkedIn AI Recommendation</span>
                    <span
                      style={{
                        backgroundColor: "#0a66c2",
                        color: "#ffffff",
                        borderRadius: "10px",
                        padding: "0px 6px",
                        fontSize: "11px",
                        fontWeight: "bold",
                        marginLeft: "2px",
                        lineHeight: "16px",
                        display: "inline-block",
                      }}
                    >
                      {linkedinProfilesData.active_profiles.length}
                    </span>
                  </button>
                )}

                {feedback && feedback.state !== "not_due" && (
                  <button
                    className="btn relative flex items-center gap-1 max-w-[170px] overflow-hidden"
                    onClick={() => setShowFeedback(true)}
                    title={feedback.state === "due" ? "Feedback due: request client feedback" : "Client feedback"}
                  >
                    <i className="fa-regular fa-star shrink-0" />
                    <span className="truncate">Client feedback</span>
                    {(feedback.state === "due" || feedback.state === "received") && (
                      <span
                        className={`h-2 w-2 shrink-0 rounded-full ${feedback.state === "due" ? "bg-amber-500" : "bg-emerald-500"}`}
                        aria-label={feedback.state === "due" ? "Feedback due" : "Feedback received"}
                      />
                    )}
                  </button>
                )}

                <div>
                  <ProjectDetailsStatus
                    project_status={project.status}
                    project_id={parseInt(id)}
                    setConfirmPopup={setConfirmPopup}
                    setProjectLost={setProjectLost}
                    projectStatus={projectStatus}
                    setProjectStatus={setProjectStatus}
                  />
                </div>
              </div>
            </div>

            {feedback?.state === "due" && (
              <div role="status" className="my-2 flex flex-wrap items-center justify-between gap-2 rounded-xl border border-amber-200 bg-amber-50 px-[16px] py-2 text-sm text-amber-900">
                <span className="flex items-center gap-2">
                  <i className="fa-regular fa-clock" aria-hidden="true" />
                  This project finished on{" "}
                  {new Date(`${feedback.finishDate}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}.
                  Ask the client for feedback.
                </span>
                <button
                  className="rounded-full bg-[#365561] px-[12px] py-1 text-xs font-semibold text-white transition hover:bg-[#2c4650]"
                  onClick={() => setShowFeedback(true)}
                >
                  Request feedback
                </button>
              </div>
            )}
            {showFeedback && (
              <FeedbackModal
                projectId={id}
                projectName={project?.name}
                initialData={feedback}
                onClose={() => setShowFeedback(false)}
                onChange={(d) => (d?.state ? setFeedback(d) : loadFeedbackState())}
              />
            )}

            {/* <div className="flex flex-wrap justify-between items-center w-full border" style={navbarStyle}>
              <div className="project-inside-navbar min-w-[420px]">
                <StatusList
                  project_id={id}
                  tableData={tableData}
                  applyCounter={applyCounter}
                />
              </div>
              <div className="flex flex-col 2xl:flex-row">

                <div className="project-inside-navbar project-navbar-left">
                  {showButtons && (
                    <MSbuttons
                      clientLogo={clientLogo}
                      project_id={id}
                      expertIds={expertIds}
                      continueWithoutLogo={continueWithoutLogo}
                      setContinueWithoutLogo={setContinueWithoutLogo}
                      setAddLogoPopUp={setAddLogoPopUp}
                      project_name={project?.name}
                      setEmailDetails={setEmailDetails}
                      setComposeEmail={setComposeEmail}
                    />
                  )}
                </div>

                <div className="flex flex-row project-inside-navbar project-navbar-right">
                  <div className="dropdown">
                    <button
                      className="btn dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Info
                    </button>

                    <div
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                      style={{ width: "200px", textAlign: "center" }}
                    >
                      <ProjectCalender projectID={id} />
                      <Link
                        to={`/app/ProjectSummary/${id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button className="btn" style={{ width: "100%" }}>
                          <i className="fa-solid fa-chart-column" /> Summary
                        </button>
                      </Link>
                      <Link to={`/app/AccountDetails/${id}`}>
                        <button
                          className="btn dropdown-item"
                          style={{ width: "100%" }}
                        >
                          <i className="fa-regular fa-address-book" /> Account
                          Details
                        </button>
                      </Link>
                      {projectInfo ? (
                        <ViewProjectInfo
                          projectInfo={projectInfo}
                          setShowProjectInfo={setShowProjectInfo}
                        />
                      ) : null}
                      <button
                        className="btn dropdown-item"
                        onClick={() => setIsProjectCalendarOpen(true)}
                      >
                        <a>
                          <i class="fa-solid fa-calendar-days"></i> Calendar
                        </a>
                      </button>
                    </div>
                  </div>
                  <div className="dropdown">
                    <button
                      className="btn dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {isSuggestionFetching ? (
                        <i class="fa-solid fa-spinner fa-spin"></i>
                      ) : (
                        "Actions"
                      )}
                    </button>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                      style={{ width: "200px", textAlign: "center" }}
                    >
                      <button
                        className="btn"
                        onClick={() => fetchSuggestions()}
                        style={{ width: "100%" }}
                      >
                        <i className="fa-solid fa-arrow-up-right-from-square" /> AI
                        Suggestion
                      </button>
                      <button
                        className="btn"
                        onClick={() => setShowEmailTemplate(true)}
                        style={{ width: "100%" }}
                      >
                        <i className="fa-regular fa-envelope" /> Template
                      </button>
                    </div>
                  </div>

                  <button className="btn" onClick={() => setOpenSearch(true)}>
                    <i className="fa-solid fa-database" /> Search database
                  </button>
                  <button className="btn" onClick={handleAISearch}>
                    <i className="fa-solid fa-robot" /> AI Search
                  </button>
                  <button className="btn" onClick={() => closeLinkedinSearch()}>
                    <i className="fa fa-linkedin" /> Search LinkedIn
                  </button>
                  <div>
                    <ProjectDetailsStatus
                      project_status={project.status}
                      project_id={parseInt(id)}
                      setConfirmPopup={setConfirmPopup}
                      setProjectLost={setProjectLost}
                      projectStatus={projectStatus}
                      setProjectStatus={setProjectStatus}
                    />
                  </div>
                </div>
              </div>
            </div> */}

            <div className="prjdetails-table">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <ul className="prjdetails-filters list-unstyled form-inline">
                    <li
                      className="prjdetails-filter"
                      style={{ display: "inline-flex" }}
                    >
                      <span
                        className="no-select"
                        style={{ marginLeft: "16px", marginTop: "3px" }}
                      >
                        Select All
                      </span>
                      <div className="prjdetails-selectAll">
                        <input
                          className="single-checkbox"
                          type="checkbox"
                          placeholder="Select All"
                          onChange={(e) => {
                            if (e.target.checked) {
                              const expertIDs = tableData
                                .map((item) => item.expert?.ID)
                                .filter(Boolean);
                              setExpertIds(expertIDs);
                            } else {
                              const expertIDs = [];
                              setExpertIds(expertIDs);
                            }
                          }}
                        />
                      </div>
                    </li>
                    <li className="prjdetails-filter" style={{ left: "-200px" }}>
                      <span className="no-select">Search Name</span>
                      <div className="prjdetails-searchbox">
                        <input
                          className={
                            searchExpand
                              ? "prjdetails-search-input prjdetails-search-expand"
                              : "prjdetails-search-input"
                          }
                          placeholder="Search Name"
                          onChange={(e) => {
                            setFilterName(e.target.value);
                          }}
                          value={filterName}
                          ref={nameInputRef}
                        />
                        <i
                          className="prjdetails-search-icon fa-solid fa-magnifying-glass"
                          onClick={(e) => {
                            setSearchExpand(!searchExpand);
                          }}
                        />
                      </div>
                    </li>{" "}
                  </ul>
                  <ul className="prjdetails-filters list-unstyled form-inline">
                    <li
                      className="search-con-location-filter"
                      style={{ left: "-260px" }}
                    >
                      <span className="no-select">Location</span>
                      <div className="search-con-searchLoc-box">
                        <input
                          className={
                            locationExpand
                              ? "search-con-searchLoc-input search-con-location-expand"
                              : "search-con-searchLoc-input"
                          }
                          placeholder="Location"
                          onChange={(e) => setFilterLocation(e.target.value)}
                          value={filterLocation}
                          ref={locationInputRef}
                        />
                        <i
                          className="search-con-searchLoc-icon fa-solid fa-magnifying-glass"
                          onClick={(e) => {
                            setLocationExpand(!locationExpand);
                            // locationInputRef.current.focus()
                          }}
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="prjdetails-filters list-unstyled form-inline">
                    <li className="pjdetails-filter-li no-select">
                      <select
                        className="pjdetails-status-filter"
                        style={{ marginLeft: "-140px" }}
                        value={statusFilter}
                        onChange={(e) => {
                          setStatusFilter(e.target.value);
                        }}
                      >
                        <option value="">All Stages</option>
                        <option value="0">No Information</option>
                        <option value="Responded">Responded</option>
                        <option value="Interested">Interested</option>
                        <option value="Partially Available">
                          Partially Available
                        </option>
                        <option value="Not Interested">Not Interested</option>
                        <option value="Participated">Participated</option>
                      </select>
                    </li>
                  </ul>
                  <p>{""}</p>
                  <p>{""}</p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  {projectSupporter ? (
                    <>
                      {projectSupporter.map((user) => {
                        if (user.profilePicture) {
                          return (
                            <>
                              <img
                                src={
                                  user.profilePicture?.includes("data:image")
                                    ? user.profilePicture
                                    : user.profilePicture !== ""
                                    ? `${databaseLink}${user.profilePicture}`
                                    : userDefaultImage
                                }
                                width={24}
                                height={24}
                                alt="user"
                                className="rounded-circle"
                                title={user.username}
                                style={{ height: "32px", width: "32px" }}
                              />
                            </>
                          );
                        }
                      })}
                    </>
                  ) : null}
                </div>
              </div>

              <ConsultantRequests
                project_id={id}
                project_name={project?.name}
                setEmailDetails={setEmailDetails}
                setComposeEmail={setComposeEmail}
                backupData={backupData}
                setBackupData={setBackupData}
                screeningQuestions={screeningQuestions}
                projectType={project?.cons_exp}
              />
              {dataFetched ? (
                <>
                  {tableData?.length > 0 &&
                    tableData?.map((item, index) => (
                      <ProjectExpertRow
                        // key={index}
                        key={`${item.expert.ID}-${
                          item.project_id || id
                        }-${index}`}
                        data={item}
                        project_id={id}
                        appendExpertId={appendExpertId}
                        removeExpertId={removeExpertId}
                        project_name={project?.name}
                        backupData={backupData}
                        setBackupData={setBackupData}
                        setEmailButtonClicked={setEmailButtonClicked}
                        setSelectedConsulData={setSelectedConsulData}
                        setEmailDetails={setEmailDetails}
                        setComposeEmail={setComposeEmail}
                        fieldsLoading={fieldsLoading}
                        screeningQuestions={screeningQuestions}
                        projectType={projectInfo?.consExp}
                        expertIDs={expertIds}
                        tableData={tableData}
                        setTableData={setTableData}
                        doRefresh={doRefresh}
                        setDoRefresh={setDoRefresh}
                        currentExpertID={currentExpertID}
                        setCurrentExpertID={setCurrentExpertID}
                        username={userData?.username}
                      />
                    ))}

                  <RejectedRequests
                    project_id={id}
                    project_name={project?.name}
                    setEmailDetails={setEmailDetails}
                    setComposeEmail={setComposeEmail}
                    backupData={backupData}
                    setBackupData={setBackupData}
                    screeningQuestions={screeningQuestions}
                    projectType={project?.cons_exp}
                    username={userData?.username}
                  />
                  {!noConFound && tableData && tableData?.length === 0 && (
                    <div className="topCon-table-row">
                      <div className="topCon-top-div" style={{ height: "45px" }}>
                        <h5 style={{ textAlign: "center", paddingTop: "10px" }}>
                          No consultant found
                        </h5>
                      </div>
                      <div className="topCon-row-bottom"></div>
                    </div>
                  )}
                  {noConFound && (
                    <div className="topCon-table-row">
                      <div className="topCon-top-div" style={{ height: "45px" }}>
                        <h5 style={{ textAlign: "center", paddingTop: "10px" }}>
                          No consultant added yet
                        </h5>
                      </div>
                      <div className="topCon-row-bottom"></div>
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <img
                    src={LoadingIcon}
                    alt="Loading..."
                    style={{ height: "50px" }}
                  />
                  <h4 style={{ marginTop: "20px" }}>please wait</h4>
                </div>
              )}

              {composeEmail && (
                <EmailComposer
                  emailDetails={emailDetails}
                  onClose={() => setComposeEmail(false)}
                  onSend={(modifiedEmail) => {
                    setLoadingPopup(true);

                    // Handle the sending logic here, e.g., make an API call to send the modified email
                    console.log("Sending modified email:", modifiedEmail);
                    // Close the EmailComposer component
                    const authToken = localStorage.getItem("accesstoken");
                    const tokenObj = localStorage.getItem("eph-token");
                    const url = `${API_URL}send-email-through-graphapi`;
                    // const url = "https://test.expertpowerhouse.com/api/send-email-through-graphapi";
                    fetch(url, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": authToken,
                        tokenObj: JSON.parse(tokenObj).value,
                      },
                      body: JSON.stringify(modifiedEmail),
                    })
                      .then((res) => res.json())
                      .then((data) => {
                        setLoadingPopup(false);

                        if (data.status === "success") {
                          setComposeEmail(false);
                          // setDoRefresh(!doRefresh);
                          if ("experts" in data) {
                            const expertDetails = data.experts
                              .map(
                                (expert) =>
                                  `${expert[1]}: ${expert[expert.length - 1]}`
                              )
                              .join("\n");

                            Swal.fire({
                              icon: "success",
                              title: `Email sent successfully\n${expertDetails}`,
                              showConfirmButton: true,
                              // timer: 1500,
                            });
                          } else {
                            Swal.fire({
                              icon: "success",
                              title: "Email sent successfully",
                              showConfirmButton: false,
                              timer: 1500,
                            });
                          }
                        } else if (data.status === "error") {
                          Swal.fire({
                            icon: "success",
                            title: "Error",
                            text: `${data.message}`,
                            showConfirmButton: false,
                            timer: 1500,
                          });
                        }

                        // setProjectInfo(data.projectInfo);
                      })
                      .catch((err) => console.log(err));
                  }}
                />
              )}
              {confirmPopup && (
                <div className="deletePrj-popup-wrapper">
                  <div className="tab-pane fade show deletePrj-div">
                    <div>
                      <center>
                        <img
                          src={errorRedIcon}
                          width="50px"
                          height="50px"
                          alt=""
                        />
                        <p>
                          Would you like to add participated details or close the
                          project?
                        </p>
                        <br />
                      </center>
                    </div>
                    <div>
                      <center>
                        <button
                          className="btn btn-light"
                          id="closeProject"
                          onClick={handlePopupAction}
                        >
                          Close the project
                        </button>
                        <button
                          className="btn base-btn"
                          id="addDetails"
                          style={{ marginLeft: "6px" }}
                          onClick={handlePopupAction}
                        >
                          Add Details
                        </button>
                      </center>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="container-div">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "15%",
            }}
          >
            <i
              class="fa-solid fa-spinner fa-spin"
              style={{ fontSize: "100px", color: "#365561" }}
            ></i>
          </div>
        </div>
      )}

      {projectLost && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <div>
              <center>
                {/* <img src={errorRedIcon} width="50px" height="50px" alt="" /> */}
                <p>
                  <strong>Reason for Project Lost</strong>
                </p>
                <br />
                <select
                  className="resasonsLost"
                  onChange={(e) => onOptionChange(e.target.value)}
                  // value={projectStatus}
                >
                  <option value="">Select an option</option>
                  {reasonLostOptions.map((reason) => (
                    <option value={reason}>{reason}</option>
                  ))}
                </select>
                <br />
                <br />
                {otherSelected && (
                  <>
                    <input
                      type="text"
                      placeholder="Other reason"
                      onChange={(e) => setReasonLost(e.target.value)}
                    />
                    <br></br>
                    <br></br>
                  </>
                )}
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn btn-light"
                  onClick={() => {
                    setProjectLost(false);
                    setOtherSelected(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: "6px" }}
                  onClick={handleSubmitReason}
                >
                  Submit
                </button>
              </center>
            </div>
          </div>
        </div>
      )}

      {/* {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>Please wait . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )} */}
      {showProjectInfo && (
        <div className="project-info-popup-wrapper">
          <div className="tab-pane fade show project-info-div">
            <i
              className="pjinfo-close-icon fa-regular fa-rectangle-xmark"
              onClick={() => setShowProjectInfo(false)}
            ></i>
            <div className="form-card review-project-setup">
              <h4 className="text-muted" style={{ fontWeight: "bold" }}>
                <b>Project Details</b>
              </h4>
              <div className="row">
                <p className="col-3 text-muted">Client Name</p>
                <p
                  className="col-9"
                  style={sanitize ? { fontStyle: "italic" } : null}
                >
                  {!sanitize ? projectInfo.clientName : "Sanitized Mode"}
                </p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Lead Email</p>
                <p
                  className="col-9"
                  style={sanitize ? { fontStyle: "italic" } : null}
                >
                  {!sanitize ? projectInfo.justInCase : "Sanitized Mode"}
                </p>
              </div>
              {projectInfo.additionalEmails.length > 0 && (
                <div className="row">
                  <p className="col-3 text-muted">Additional Email</p>
                  <p className="col-9">
                    {projectInfo.additionalEmails.map((value, index) => {
                      const isLastElement =
                        index === projectInfo.additionalEmails.length - 1;
                      return (
                        <span key={index}>
                          {value}
                          {!isLastElement && "; "}
                        </span>
                      );
                    })}
                  </p>
                </div>
              )}
              <div className="row">
                <p className="col-3 text-muted">Project Name</p>
                <p className="col-9">
                  {!sanitize
                    ? projectInfo.name
                    : `Sanitized Mode - ${projectInfo.name.split("-")[1]}`}
                </p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Project Description</p>
                <p
                  className="col-9"
                  style={{
                    wordWrap: "break-word",
                    wordBreak: "normal",
                    whiteSpace: "pre-wrap",
                  }}
                  dangerouslySetInnerHTML={{ __html: projectInfo.description }}
                ></p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Published</p>
                <p
                  className="col-9"
                  style={{
                    wordWrap: "break-word",
                    wordBreak: "normal",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {projectInfo.published ? "Yes" : "No"}
                </p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Profile Type</p>
                <p className="col-9">
                  {projectInfo.consExp === "con"
                    ? "Consultants (Long-term project support)"
                    : projectInfo.consExp === "exp"
                    ? "Experts (Expert call)"
                    : ""}
                </p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Proposal</p>
                <p className="col-9">{projectInfo.proposal ? "Yes" : "No"}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Region</p>
                <p className="col-9">{projectInfo.region}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Country</p>
                <p className="col-9">{projectInfo.country}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Industry Preference</p>
                <p className="col-9">{projectInfo.industryPref}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Industry</p>
                <p className="col-9">{projectInfo.industry}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Daily Budget</p>
                <p className="col-9">{projectInfo.projBudget}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Project Category</p>
                <p className="col-9">{projectInfo.projCategory}</p>
              </div>
              <br />
              <h4 className="text-muted mt-3" style={{ fontWeight: "bold" }}>
                <b>Profile Details</b>
              </h4>
              <div className="row">
                <p className="col-3 text-muted">Seniority</p>
                <p className="col-9">{projectInfo.yearsOfExperience}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Skills</p>
                <p className="col-9">{projectInfo.skills}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Language (code)</p>
                <p className="col-9" style={{ textTransform: "uppercase" }}>
                  {projLanguages}
                </p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Project Start Date</p>
                <p className="col-9">{projStartDate}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Deadline</p>
                <p className="col-9">{projDeadline}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Project Duration</p>
                <p className="col-9">{projectInfo.projectDuration}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Type of Employment</p>
                <p className="col-9">{projectInfo.employmentType}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Utilization Intensity</p>
                <p className="col-9">{projectInfo.utilizationIntensity}%</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Total Days</p>
                <p className="col-9">{projectInfo.daysUsed}</p>
              </div>
            </div>
            <div>
              <center>
                <button
                  type="button"
                  className="btn base-btn prjdetails-editCancel"
                  onClick={() => setShowProjectInfo(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn base-btn prjdetails-editCancel"
                  onClick={() => {
                    navigate("/app/ProjectSetup/" + projectInfo.id);
                  }}
                >
                  Edit
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
      {showEmailTemplate && (
        <EmailTemplate
          project_name={project?.clientName + " - " + project?.name}
          project_id={id}
          setShowEmailTemplate={setShowEmailTemplate}
        />
      )}

      {openSearch && (
        // <DatabasePopup projectID={id} setOpenSearch={setOpenSearch} />
        <DatabaseSearchDrawer
          projectID={id}
          userID={userData?.id}
          onClose={setOpenSearch}
          onAddToProject={handleDatabaseSearchAdd}
        />
      )}
      {openLinkedinSearch && (
        <AdvancedFiltersPopup
          isOpen={openLinkedinSearch}
          onClose={closeLinkedinSearch}
          onApplyFilters={handleApplyFilters}
          onFiltersSaved={setSavedLinkedinFilters}
          projectId={id}
          project={project}
          initialFilters={linkedinInitialFilters}
          allProjectFilters={allProjectFilters}
        />
      )}

      <AISearchModal
        isOpen={showAISearchModal}
        onClose={() => setShowAISearchModal(false)}
        results={aiSearchResults[id]?.experts || []}
        isLoading={aiSearchLoading}
        tableData={tableData}
        setDoRefresh={setDoRefresh}
        projectId={id}
        setAiSearchResults={setAiSearchResults}
      />

      {showLinkedInAIModal && (
        <LinkedInAIModal
          isOpen={showLinkedInAIModal}
          onClose={() => setShowLinkedInAIModal(false)}
          projectId={id}
          apiUrl={API_URL}
          activeProfiles={linkedinProfilesData?.active_profiles || []}
          onDiscardSuccess={handleLinkedInDiscardSuccess}
          loadingProfiles={loadingLinkedinProfiles}
          fetchLinkedInProfiles={fetchLinkedInProfiles}
          tableData={tableData}
          onProjectRefresh={() => setDoRefresh((prev) => !prev)}
        />
      )}

      {suggestionFetched && (
        <ExpertSuggestionPanel
          suggestions={expertSuggestions}
          projectID={id}
          onClose={handleSuggestionClose}
        />
      )}

      {isProjectCalendarOpen && (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-30">
          <EphProjectCalendar 
            expertID={null}
            projectID={id}
            expertList={expertList}
            setOpenCall={setIsProjectCalendarOpen}
          />
        </div>
      )}
    </>
  );
}

export function ExpertSuggestionPanel({ suggestions, projectID, onClose }) {
  const { API_URL } = useContext(UrlContext);
  const mediaLink = "https://media.licdn.com/";
  const databaseLink = "https://images.expertpowerhouse.com";
  const [selectedExpertIds, setSelectedExpertIds] = useState([]);
  const [isAdding, setIsAdding] = useState(false);

  const handleCheckboxToggle = (expertId) => {
    setSelectedExpertIds((prev) =>
      prev.includes(expertId)
        ? prev.filter((id) => id !== expertId)
        : [...prev, expertId]
    );
  };

  const addExpertsToProject = async () => {
    setIsAdding(true);
    const tokenObj = localStorage.getItem("eph-token");
    const ephToken = JSON.parse(tokenObj).value;
    try {
      const response = await fetch(`${API_URL}add-from-AI-suggestion`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          expertIDList: selectedExpertIds,
          projectID: projectID,
          ephToken: ephToken,
        }),
      });

      const result = await response.json();

      if (result.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Added!",
          text: "All selected experts were added to the project.",
          timer: 1500,
          showConfirmButton: false,
          willClose: () => {
            window.location.reload();
          },
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Some Experts Not Added",
          text: result.text || "Something went wrong while adding experts.",
        });
      }
    } catch (error) {
      console.error("Add to project error:", error);
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Unable to add experts at the moment. Please try again later.",
      });
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <AnimatePresence>
      {/* Background Overlay */}
      <motion.div
        className="fixed inset-0 bg-black/30 z-30"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        // onClick={onClose}
      />

      {/* Panel */}
      <motion.div
        className="fixed top-[78px] right-0 h-full w-[700px] bg-white shadow-xl z-40 pt-2 px-4 pb-6 flex flex-col"
        initial={{ x: "100%" }}
        animate={{ x: 0 }}
        exit={{ x: "100%" }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
      >
        <div className="flex justify-between items-center mb-4">
          <div className="flex flex-row justify-center items-center gap-2">
            <h2 className="text-lg font-semibold text-gray-800">
              Suggested Experts
            </h2>
            {selectedExpertIds.length > 0 && (
              <button
                onClick={() => addExpertsToProject()}
                className="bg-[#365561] hover:bg-[#2b4351] text-white text-sm px-2 py-1 w-[110px] rounded"
                disabled={isAdding}
              >
                {isAdding ? (
                  <i class="fa-solid fa-spinner fa-spin"></i>
                ) : (
                  <p>Add to Project</p>
                )}
              </button>
            )}
          </div>
          <button
            className="text-gray-500 hover:text-black hover:bg-gray-200 px-2 py-0 rounded-full transition"
            onClick={onClose}
          >
            <i className="fa-solid fa-xmark text-lg"></i>
          </button>
        </div>

        {suggestions.length > 0 ? (
          <div className="space-y-3 overflow-y-auto flex-1">
            {suggestions.map((data) => (
              <div
                key={data.expert_id}
                className="relative flex flex-row border rounded-lg shadow-sm hover:bg-gray-50 transition"
              >
                <div className="absolute -top-0.5 right-0 z-10">
                  <input
                    type="checkbox"
                    checked={selectedExpertIds.includes(data.expert_id)}
                    onChange={() => handleCheckboxToggle(data.expert_id)}
                    className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                </div>
                <a
                  href={`/app/ExpertDetails/${data.expert.ID}`}
                  target="_blank"
                  rel="noreferrer"
                  className="w-[90px]"
                >
                  <img
                    src={
                      data.expert.profilePicture?.includes(mediaLink)
                        ? data.expert.profilePicture
                        : `${databaseLink}${data.expert.profilePicture}`
                    }
                    alt="Expert"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://images.expertpowerhouse.com/pictures/dummy.png";
                    }}
                    className="w-full h-full object-cover rounded-md bg-[#365561]"
                  />
                </a>
                <div className="flex flex-col">
                  <p className="text-md font-medium text-gray-800 p-2">
                    {data.expert.Name}
                  </p>
                  <div className="flex flex-row">
                    <div className="flex flex-col pl-2 pr-2 pb-2">
                      <p className="text-sm text-gray-500">
                        Summery Similarity: {data.features[0].toFixed(3)}
                      </p>
                      <p className="text-sm text-gray-500">
                        Skills Overlap: {data.features[1].toFixed(3)}
                      </p>
                      <p className="text-sm text-gray-500">
                        Industries Overlap: {data.features[2].toFixed(3)}
                      </p>
                      <p className="text-sm text-gray-500">
                        Category Overlap: {data.features[3].toFixed(1)}
                      </p>
                      <p className="text-sm text-gray-500">
                        Language Match: {data.features[4].toFixed(1)}
                      </p>
                      <p className="text-sm text-gray-500">
                        Region Match: {data.features[5].toFixed(1)}
                      </p>
                      <p className="text-sm text-gray-500">
                        Highest Engagments: {data.features[6].toFixed(2)}
                      </p>
                      <p className="text-sm text-gray-500">
                        Score: {data.score.toFixed(3)}
                      </p>
                    </div>
                    <div className="flex flex-col pl-2 pr-2 pb-2 w-[350px] space-y-2">
                      <div>
                        <p className="text-xs text-gray-500 font-medium mb-1">
                          Summary
                        </p>
                        <div className="bg-gray-100 p-2 rounded text-sm text-gray-700 max-h-16 overflow-y-auto whitespace-pre-wrap">
                          {data.expert.summ || "No summary available."}
                        </div>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 font-medium mb-1">
                          Experience
                        </p>
                        <div className="bg-gray-100 p-2 rounded text-sm text-gray-700 max-h-16 overflow-y-auto whitespace-pre-wrap">
                          {data.expert.experience || "No experience provided."}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-sm">No experts found.</p>
        )}
        <div className="mb-[70px]"></div>
      </motion.div>
    </AnimatePresence>
  );
}
